import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Video from 'components/Video';
import { LandingPageContextEnum } from 'enums';
import { useStyles } from './styles';
import EmailFormVariant from 'components/EmailFormVariant';

export default function Header() {
  const classes = useStyles();

  return (
    <Box id="header" className={classes.root}>
      <Container>
        <Box className={classes.content}>
          <Box>
            <Typography className={classes.titleGraphical} variant="h1">
              <b>
                Online graphical &nbsp;
                <br /> abstract maker tool
              </b>
            </Typography>

            <Box py={3}>
              <Typography>
                Make a powerful graphical abstract in minutes <br /> and give readers an immediate{' '}
                understanding <br /> of your scientific paper. Design custom graphical <br />{' '}
                abstract templates that perfectly match your <br /> research and publication needs.
              </Typography>
            </Box>

            <EmailFormVariant
              context={LandingPageContextEnum.CREATE_GRAPHICAL_ABSTRACT}
              buttonLoggedColor="default"
              buttonColor="primary"
              textButtonLogged="Start Creating Now"
              labelColor="white"
              textAgreeColor="white"
            />
          </Box>

          <Box className={classes.videoWrapper}>
            <Video
              className={classes.video}
              sources={[
                { src: '/videos/graphical-abstract/header-banner-new.mp4', type: 'video/mp4' },
              ]}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
